const productVideo = () => {
  const productVideoElems = document.querySelectorAll('[data-product-video]');

  if (productVideoElems.length === 0) {
    return false;
  }

  productVideoElems.forEach(productVideoElem => {
    initVideo(productVideoElem);
  });
};

const initVideo = productVideoElem => {
  const playButton = productVideoElem.querySelector(
    '[data-product-video-play-button]'
  );

  const videoTag = productVideoElem.querySelector('video');

  if (!playButton || !videoTag) {
    return false;
  }

  productVideoElem.addEventListener('click', () => {
    playButton.classList.add('is-hidden');
    videoTag.setAttribute('controls', 'controls');
    videoTag.play();
  });
};

export default productVideo;
